import React, { useState } from "react";
import axios from "axios";
import bgImage from "../../../Assets/InitialRegistration/Workshop_panel1.png";

function InitialRegistration() {

const emptyForm = {
policy:"",
workshop:"",
vehicle:"",
pincode:"",
location:"",
accidentDate:"",
phone:"",
email:"",
status:"not completed",
vehicleDetails: null,
driverDetails: null
};

const emptySearchForm = {
vehicleNumber: "",
dlNumber: "",
dob: ""
};

const [cases,setCases] = useState([]);
const [formData,setFormData] = useState(emptyForm);
const [searchFormData, setSearchFormData] = useState(emptySearchForm);
const [search,setSearch] = useState("");
const [filter,setFilter] = useState("all");
const [showForm,setShowForm] = useState(false);
const [showSearchModal,setShowSearchModal] = useState(false);
const [viewData,setViewData] = useState(null);
const [editId,setEditId] = useState(null);
const [loading,setLoading] = useState(false);
const [error,setError] = useState("");
const [errorType,setErrorType] = useState(null);
const [fetchedDetails,setFetchedDetails] = useState(null);

const handleChange=(e)=>{
setFormData({...formData,[e.target.name]:e.target.value});
};

const handleSearchChange=(e)=>{
setSearchFormData({...searchFormData,[e.target.name]:e.target.value});
};

const fetchDetailsFromULIP = async () => {
  setLoading(true);
  setError("");
  setErrorType(null);
  try {
    const baseURL = process.env.REACT_APP_BACKEND_URL;
    const response = await axios.get(`${baseURL}/api/ulip/fetch-details`, {
      params: {
        vehicleNumber: searchFormData.vehicleNumber,
        dlNumber: searchFormData.dlNumber,
        dob: searchFormData.dob
      }
    });

    const data = response.data;
    setFetchedDetails(data);
    
    if (data.vehicleDetails) {
      setFormData({
        ...formData,
        vehicle: searchFormData.vehicleNumber,
        vehicleDetails: data.vehicleDetails,
        driverDetails: data.driverDetails
      });
    }
  } catch (err) {
    const status = err.response?.status;
    const message = err.response?.data?.error || err.message;
    
    if (status === 404) {
      setErrorType("not_found");
      setError(`Vehicle not found. Please check the vehicle number and try again.`);
    } else if (status === 400) {
      setErrorType("invalid_input");
      setError(message || "Invalid input. Please check your details.");
    } else if (!err.response) {
      setErrorType("network");
      setError("Network error. Please check your connection and try again.");
    } else {
      setErrorType("server");
      setError(message || "Server error. Please try again later.");
    }
    console.error(err);
  } finally {
    setLoading(false);
  }
};

const submitCase=()=>{

if(editId){
setCases(cases.map(c=>c.id===editId ? {...formData,id:editId}:c));
}else{
setCases([...cases,{...formData,id:Date.now()}]); // Using timestamp as a simple unique ID
}

setFormData(emptyForm);
setShowForm(false);
setEditId(null);

};

const editCase=(data)=>{
setFormData(data);
setEditId(data.id);
setShowForm(true);
};

const deleteCase=(id)=>{
if(window.confirm("Delete this case?")){
setCases(cases.filter(c=>c.id!==id));
}
};

const filteredCases = cases.filter(c=>{

const matchesSearch =
c.vehicle.toLowerCase().includes(search.toLowerCase()) ||
c.workshop.toLowerCase().includes(search.toLowerCase());

const matchesFilter =
filter==="all" ? true : c.status===filter;

return matchesSearch && matchesFilter;

});

return(
<div style={{minHeight:"100vh",position:"relative"}}>

{/* Background */}

<div style={{
position:"absolute",
inset:0,
backgroundImage:`url(${bgImage})`,
backgroundSize:"cover",
backgroundPosition:"top center",
filter:"blur(4px) brightness(0.8)"
}}/>

{/* Dashboard */}

<div style={dashboardCard}>

{/* TOP BAR */}

<div style={topBar}>

<button onClick={()=>{
setShowSearchModal(true);
setSearchFormData(emptySearchForm);
setFetchedDetails(null);
setError("");
}} style={addBtn}>
+ Add Vehicle
</button>

<div style={{display:"flex",gap:"16px"}}>

<input
placeholder="Search By Vehicle Number"
value={search}
onChange={(e)=>setSearch(e.target.value)}
style={searchInput}
/>

{/* <select
value={filter}
onChange={(e)=>setFilter(e.target.value)}
style={filterBtn}
>
<option value="all" style={{color:"black"}}>All Cases</option>
<option value="completed" style={{color:"black"}}>Completed</option>
<option value="not completed" style={{color:"black"}}>Not Completed</option>
</select> */}

</div>
</div>

{/* TABLE */}

<div style={tableContainer}>

<table style={table}>

<thead>
<tr style={tableHeader}>
<th style={th}>ID</th>
<th style={th}>Workshop</th>
<th style={th}>Vehicle</th>
<th style={th}>Phone</th>
<th style={th}>Status</th>
<th style={th}>Actions</th>
</tr>
</thead>

<tbody>

{filteredCases.map((c,index)=>(

<tr key={c.id} style={{
background:index%2?"#0f172a":"#1e293b",
textAlign:"center"
}}>

<td style={td}>{c.id}</td>
<td style={td}>{c.workshop}</td>
<td style={td}>{c.vehicle}</td>
<td style={td}>{c.phone}</td>

<td style={td}>
<span style={{
padding:"6px 16px",
borderRadius:"20px",
fontSize:"13px",
background:c.status==="completed"
? "rgba(34,197,94,0.25)"
: "rgba(251,146,60,0.25)",
color:c.status==="completed"
? "#22c55e"
: "#fb923c"
}}>
{c.status}
</span>
</td>

<td style={td}>

<div style={{display:"flex",gap:"10px",justifyContent:"center"}}>

<button onClick={()=>setViewData(c)} style={viewBtn}>View</button>
<button onClick={()=>editCase(c)} style={editBtn}>Edit</button>
<button onClick={()=>deleteCase(c.id)} style={deleteBtn}>Delete</button>

</div>

</td>

</tr>

))}

</tbody>
</table>

</div>

</div>

{/* ULIP SEARCH MODAL */}

{showSearchModal && (

<div style={modalBg}>

<div style={searchModalCard}>

<div style={searchModalHeader}>
<h2 style={{margin:0,color:"#fff"}}>Fetch Vehicle & Driver Details</h2>
<button onClick={()=>setShowSearchModal(false)} style={closeIconBtn}>✕</button>
</div>

{error && errorType === "not_found" && (
<div style={errorNotFound}>
<div style={{display:"flex",alignItems:"flex-start",gap:"12px"}}>
<div style={errorIconNotFound}>🚗</div>
<div>
<p style={{margin:"0 0 4px 0",fontWeight:"600",color:"#dc2626"}}>Vehicle Not Found</p>
<p style={{margin:0,fontSize:"13px",color:"#991b1b"}}>{error}</p>
</div>
</div>
</div>
)}

{error && errorType === "invalid_input" && (
<div style={errorInvalidInput}>
<div style={{display:"flex",alignItems:"flex-start",gap:"12px"}}>
<div style={errorIconInvalid}>⚠️</div>
<div>
<p style={{margin:"0 0 4px 0",fontWeight:"600",color:"#d97706"}}>Invalid Input</p>
<p style={{margin:0,fontSize:"13px",color:"#92400e"}}>{error}</p>
</div>
</div>
</div>
)}

{error && errorType === "network" && (
<div style={errorNetwork}>
<div style={{display:"flex",alignItems:"flex-start",gap:"12px",justifyContent:"space-between",width:"100%"}}>
<div style={{display:"flex",alignItems:"flex-start",gap:"12px",flex:1}}>
<div style={errorIconNetwork}>🌐</div>
<div>
<p style={{margin:"0 0 4px 0",fontWeight:"600",color:"#7c3aed"}}>Connection Failed</p>
<p style={{margin:0,fontSize:"13px",color:"#5b21b6"}}>{error}</p>
</div>
</div>
<button onClick={fetchDetailsFromULIP} style={retryBtn}>
Retry
</button>
</div>
</div>
)}

{error && errorType === "server" && (
<div style={errorServer}>
<div style={{display:"flex",alignItems:"flex-start",gap:"12px",justifyContent:"space-between",width:"100%"}}>
<div style={{display:"flex",alignItems:"flex-start",gap:"12px",flex:1}}>
<div style={errorIconServer}>⚡</div>
<div>
<p style={{margin:"0 0 4px 0",fontWeight:"600",color:"#ea580c"}}>Server Error</p>
<p style={{margin:0,fontSize:"13px",color:"#7c2d12"}}>{error}</p>
</div>
</div>
<button onClick={fetchDetailsFromULIP} style={retryBtn}>
Retry
</button>
</div>
</div>
)}

{error && !errorType && (
<div style={errorGeneric}>
<div style={{display:"flex",alignItems:"flex-start",gap:"12px"}}>
<div style={errorIconGeneric}>❌</div>
<div>
<p style={{margin:"0 0 4px 0",fontWeight:"600",color:"#dc2626"}}>Error</p>
<p style={{margin:0,fontSize:"13px",color:"#991b1b"}}>{error}</p>
</div>
</div>
</div>
)}

<div style={searchFormGrid}>

<div style={formGroupCol2}>
<label style={formLabel}>Vehicle Number</label>
<input
name="vehicleNumber"
placeholder="e.g., DL-01-AB-1234"
value={searchFormData.vehicleNumber}
onChange={handleSearchChange}
style={searchInput}
/>
</div>

<div style={formGroupCol2}>
<label style={formLabel}>DL Number</label>
<input
name="dlNumber"
placeholder="e.g., DL-1234567890"
value={searchFormData.dlNumber}
onChange={handleSearchChange}
style={searchInput}
/>
</div>

<div style={formGroupCol2}>
<label style={formLabel}>Date of Birth</label>
<input
type="date"
name="dob"
value={searchFormData.dob}
onChange={handleSearchChange}
style={searchInput}
/>
</div>

</div>

<button 
onClick={fetchDetailsFromULIP} 
disabled={loading || !searchFormData.vehicleNumber}
style={{...fetchBtn, opacity: loading || !searchFormData.vehicleNumber ? 0.6 : 1}}
>
{loading ? "Fetching..." : "Fetch Details"}
</button>

{fetchedDetails && (

<div style={detailsContainer}>

<h3 style={{color:"#21A6E9",marginTop:"30px"}}>Vehicle Details</h3>

<div style={detailsGrid}>

{fetchedDetails.vehicleDetails && Object.entries(fetchedDetails.vehicleDetails).map(([key, value]) => (
<DetailField key={key} label={key} value={value}/>
))}

</div>

{fetchedDetails.driverDetails && (
<>
<h3 style={{color:"#21A6E9",marginTop:"25px"}}>Driver Details</h3>

<div style={detailsGrid}>

{Object.entries(fetchedDetails.driverDetails).map(([key, value]) => (
<DetailField key={key} label={key} value={value}/>
))}

</div>
</>
)}

<div style={{display:"flex",gap:"15px",marginTop:"25px"}}>

<button 
onClick={()=>{
setShowSearchModal(false);
setShowForm(true);
}}
style={confirmBtn}
>
Confirm & Proceed
</button>

<button 
onClick={()=>setShowSearchModal(false)}
style={cancelBtn}
>
Cancel
</button>

</div>

</div>

)}

</div>

</div>

)}

{/* VIEW MODAL */}

{viewData && (

<div style={modalBg}>

<div style={viewCard}>

<h2 style={viewTitle}>Case Details</h2>

<div style={viewGrid}>

<ViewField label="Policy Number" value={viewData.policy}/>
<ViewField label="Workshop Name" value={viewData.workshop}/>
<ViewField label="Vehicle Number" value={viewData.vehicle}/>
<ViewField label="Pincode" value={viewData.pincode}/>
<ViewField label="Accident Location" value={viewData.location}/>
<ViewField label="Accident Date" value={viewData.accidentDate}/>
<ViewField label="Phone Number" value={viewData.phone}/>
<ViewField label="Email" value={viewData.email}/>

</div>

<button onClick={()=>setViewData(null)} style={closeBtn}>
Close
</button>

</div>

</div>

)}

{/* FORM */}

{showForm && (

<div style={modalBg}>

<div style={formCard}>

<h2 style={{marginBottom:"25px"}}>Case Registration</h2>

<div style={formGrid}>

<input name="policy" placeholder="Policy Number" onChange={handleChange} value={formData.policy} style={input}/>
<input name="workshop" placeholder="Workshop Name" onChange={handleChange} value={formData.workshop} style={input}/>
<input name="vehicle" placeholder="Vehicle Number" onChange={handleChange} value={formData.vehicle} style={input}/>
<input name="pincode" placeholder="Pincode" onChange={handleChange} value={formData.pincode} style={input}/>
<input name="location" placeholder="Accident Location" onChange={handleChange} value={formData.location} style={input}/>
<input type="date" name="accidentDate" onChange={handleChange} value={formData.accidentDate} style={input}/>
<input name="phone" placeholder="Phone Number" onChange={handleChange} value={formData.phone} style={input}/>
<input name="email" placeholder="Email" onChange={handleChange} value={formData.email} style={input}/>

</div>

<div style={{marginTop:"25px",display:"flex",gap:"15px"}}>

<button onClick={submitCase} style={submitBtn}>Submit</button>
<button onClick={()=>setShowForm(false)} style={deleteBtn}>Cancel</button>

</div>

</div>

</div>

)}

</div>
);
}

const ViewField = ({label,value}) => (
<div style={viewItem}>
<div style={viewLabel}>{label}</div>
<div style={viewValue}>{value || "-"}</div>
</div>
);

const DetailField = ({label,value}) => (
<div style={detailItem}>
<div style={detailLabel}>{formatLabel(label)}</div>
<div style={detailValue}>{value ? String(value) : "-"}</div>
</div>
);

const formatLabel = (key) => {
return key
.replace(/([A-Z])/g, ' $1')
.replace(/_/g, ' ')
.replace(/^./, str => str.toUpperCase())
.trim();
};

/* STYLES */

const dashboardCard={
position:"relative",
margin:"20px auto",
width:"98%",
background:"rgba(255,255,255,0.12)",
backdropFilter:"blur(12px)",
borderRadius:"16px",
padding:"35px",
color:"white"
};

const topBar={
display:"flex",
justifyContent:"space-between",
alignItems:"center",
marginBottom:"25px"
};

const tableContainer={
height:"75vh",
overflowY:"auto",
borderRadius:"10px"
};

const table={
width:"100%",
borderCollapse:"collapse",
background:"rgba(0,0,0,0.65)"
};

const tableHeader={
background:"#0f172a",
color:"#21A6E9",
position:"sticky",
top:0
};

const th={padding:"14px"};
const td={padding:"14px"};

const addBtn={
background:"linear-gradient(135deg,#21A6E9,#0077b6)",
border:"none",
padding:"12px 24px",
borderRadius:"10px",
color:"white",
fontWeight:"600",
cursor:"pointer"
};

const searchInput={
padding:"12px",
width:"420px",
borderRadius:"10px",
background:"rgba(0,0,0,0.45)",
color:"white",
border:"none"
};

const filterBtn={
padding:"12px 18px",
borderRadius:"10px",
background:"#21A6E9",
color:"white",
border:"none"
};

const modalBg={
position:"fixed",
inset:0,
background:"rgba(0,0,0,0.8)",
display:"flex",
justifyContent:"center",
alignItems:"center",
padding:"40px"
};

const viewCard={
width:"900px",
background:"rgba(15,23,42,0.95)",
borderRadius:"18px",
padding:"40px",
backdropFilter:"blur(14px)",
color:"white",
boxShadow:"0 20px 60px rgba(0,0,0,0.7)"
};

const viewTitle={
marginBottom:"25px",
color:"#21A6E9"
};

const viewGrid={
display:"grid",
gridTemplateColumns:"1fr 1fr",
gap:"20px",
marginBottom:"30px"
};

const viewItem={
background:"rgba(255,255,255,0.05)",
padding:"14px",
borderRadius:"10px"
};

const viewLabel={
fontSize:"12px",
opacity:"0.7",
marginBottom:"4px"
};

const viewValue={
fontSize:"16px",
fontWeight:"600"
};

const formCard={
background:"#0f172a",
padding:"40px",
borderRadius:"12px",
maxWidth:"900px",
width:"100%"
};

const formGrid={
display:"grid",
gridTemplateColumns:"1fr 1fr",
gap:"20px"
};

const input={
padding:"12px",
borderRadius:"6px",
border:"none"
};

const submitBtn={
background:"#21A6E9",
padding:"12px 20px",
border:"none",
color:"white",
borderRadius:"8px",
fontWeight:"bold"
};

const closeBtn={
background:"#ef4444",
border:"none",
padding:"12px 20px",
color:"white",
borderRadius:"8px",
cursor:"pointer"
};

const viewBtn={background:"#3b82f6",border:"none",padding:"6px 12px",color:"white",borderRadius:"6px"};
const editBtn={background:"#f59e0b",border:"none",padding:"6px 12px",color:"white",borderRadius:"6px"};
const deleteBtn={background:"#ef4444",border:"none",padding:"6px 12px",color:"white",borderRadius:"6px"};

const searchModalCard={
background:"rgba(15,23,42,0.98)",
borderRadius:"18px",
padding:"40px",
maxWidth:"800px",
width:"100%",
boxShadow:"0 20px 80px rgba(0,0,0,0.8)",
backdropFilter:"blur(14px)",
color:"white"
};

const searchModalHeader={
display:"flex",
justifyContent:"space-between",
alignItems:"center",
marginBottom:"25px",
paddingBottom:"20px",
borderBottom:"1px solid rgba(255,255,255,0.1)"
};

const closeIconBtn={
background:"transparent",
border:"none",
color:"#ef4444",
fontSize:"28px",
cursor:"pointer",
padding:"0",
width:"30px",
height:"30px",
display:"flex",
alignItems:"center",
justifyContent:"center"
};

const errorBanner={
background:"rgba(239,68,68,0.2)",
border:"1px solid #ef4444",
color:"#fca5a5",
padding:"12px 16px",
borderRadius:"8px",
marginBottom:"20px",
fontSize:"14px"
};

const errorNotFound={
background:"rgba(220,38,38,0.1)",
border:"1px solid rgba(220,38,38,0.3)",
padding:"14px 16px",
borderRadius:"10px",
marginBottom:"20px",
display:"flex",
alignItems:"center",
gap:"12px"
};

const errorIconNotFound={
fontSize:"20px",
display:"flex",
alignItems:"center",
justifyContent:"center"
};

const errorInvalidInput={
background:"rgba(217,119,6,0.1)",
border:"1px solid rgba(217,119,6,0.3)",
padding:"14px 16px",
borderRadius:"10px",
marginBottom:"20px"
};

const errorIconInvalid={
fontSize:"20px",
display:"flex",
alignItems:"center",
justifyContent:"center"
};

const errorNetwork={
background:"rgba(124,58,237,0.1)",
border:"1px solid rgba(124,58,237,0.3)",
padding:"14px 16px",
borderRadius:"10px",
marginBottom:"20px",
display:"flex",
alignItems:"center",
gap:"12px"
};

const errorIconNetwork={
fontSize:"20px",
display:"flex",
alignItems:"center",
justifyContent:"center"
};

const errorServer={
background:"rgba(234,88,12,0.1)",
border:"1px solid rgba(234,88,12,0.3)",
padding:"14px 16px",
borderRadius:"10px",
marginBottom:"20px",
display:"flex",
alignItems:"center",
gap:"12px"
};

const errorIconServer={
fontSize:"20px",
display:"flex",
alignItems:"center",
justifyContent:"center"
};

const errorGeneric={
background:"rgba(220,38,38,0.1)",
border:"1px solid rgba(220,38,38,0.3)",
padding:"14px 16px",
borderRadius:"10px",
marginBottom:"20px"
};

const errorIconGeneric={
fontSize:"20px",
display:"flex",
alignItems:"center",
justifyContent:"center"
};

const retryBtn={
background:"transparent",
border:"1px solid currentColor",
padding:"6px 12px",
borderRadius:"6px",
color:"inherit",
fontSize:"12px",
fontWeight:"600",
cursor:"pointer",
whiteSpace:"nowrap",
transition:"all 0.2s"
};

const searchFormGrid={
display:"grid",
gridTemplateColumns:"1fr",
gap:"18px",
marginBottom:"25px"
};

const formGroupCol2={
display:"flex",
flexDirection:"column",
gap:"8px"
};

const formLabel={
fontSize:"13px",
fontWeight:"600",
color:"#94a3b8",
textTransform:"uppercase",
letterSpacing:"0.5px"
};

const fetchBtn={
background:"linear-gradient(135deg,#21A6E9,#0077b6)",
border:"none",
padding:"14px 28px",
borderRadius:"10px",
color:"white",
fontWeight:"600",
cursor:"pointer",
fontSize:"16px",
width:"100%",
transition:"all 0.3s ease"
};

const detailsContainer={
maxHeight:"400px",
overflowY:"auto",
marginTop:"20px",
paddingTop:"20px",
borderTop:"1px solid rgba(255,255,255,0.1)"
};

const detailsGrid={
display:"grid",
gridTemplateColumns:"repeat(2, 1fr)",
gap:"16px",
marginBottom:"20px"
};

const detailItem={
background:"rgba(255,255,255,0.05)",
padding:"16px",
borderRadius:"10px",
border:"1px solid rgba(255,255,255,0.08)"
};

const detailLabel={
fontSize:"12px",
color:"#94a3b8",
fontWeight:"600",
marginBottom:"6px",
textTransform:"uppercase",
letterSpacing:"0.5px"
};

const detailValue={
fontSize:"15px",
color:"#fff",
fontWeight:"500",
wordBreak:"break-word"
};

const confirmBtn={
background:"linear-gradient(135deg,#22c55e,#16a34a)",
border:"none",
padding:"12px 24px",
color:"white",
borderRadius:"8px",
fontWeight:"600",
cursor:"pointer",
flex:1
};

const cancelBtn={
background:"rgba(255,255,255,0.1)",
border:"1px solid rgba(255,255,255,0.2)",
padding:"12px 24px",
color:"white",
borderRadius:"8px",
fontWeight:"600",
cursor:"pointer",
flex:1
};

export default InitialRegistration;